import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import clsx from "clsx";

// Custom components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

// MUI
import { Stack, Checkbox, Typography, FormControlLabel } from "@mui/material";

const Separator = (props) => {
	const { label = "", classes = "", px = 0, py = 0, sx = {} } = props;
	const hasPlus = Boolean(label === "+");

	return (
		<Typography
			className={clsx({
				"small-label": true,
				"mini-plus": hasPlus,
				[classes]: classes,
			})}
			px={px}
			py={py}
			sx={{ ...sx, zIndex: 2 }}
		>
			{label}
		</Typography>
	);
};
Separator.propTypes = {
	label: PropTypes.string,
	classes: PropTypes.string,
	px: PropTypes.number,
	py: PropTypes.number,
	sx: PropTypes.object,
};

export default function CheckInput(props) {
	const {
		checkbox = {
			label: "",
			checked: false,
			handleChange: () => {},
		},
		input = {
			data: [
				{
					type: "Dollar",
					min: -1000000,
					max: 1000000,
					decimalsEditable: false,
					decimals: 2,
					dashed: true,
				},
			],
			value: 0,
			defaultType: "Dollar",
			error: false,
			disabled: false,
			readOnly: false,
			sx: { maxWidth: "95px", minWidth: "95px", marginLeft: 1 },
			onActionUpdate: () => {},
			onBlur: () => {},
			onChange: () => {},
			onClickText: () => {},
			onFocusOut: () => {},
		},
		disabled = false,
		readOnly = false,
		componentProps = {
			sx: null,
		},
	} = props;

	const [checked, setChecked] = useState(false);

	const handleCheckboxChange = (_, value) => {
		setChecked(value);
		checkbox?.handleChange?.(value);
	};

	useEffect(() => {
		setChecked(Boolean(checkbox?.checked));

		return () => {
			setChecked(false);
		};
	}, [checkbox]);

	return (
		<Stack
			direction="row"
			position={"relative"}
			justifyContent={"space-between"}
			alignContent={"center"}
			alignItems={"center"}
			sx={componentProps?.sx}
		>
			<FormControlLabel
				label={
					<Typography className={"tiered-title"} whiteSpace={"nowrap"} style={{ opacity: disabled || readOnly ? 0.5 : 1 }}>
						{checkbox?.label || ""}
					</Typography>
				}
				control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
				disabled={disabled || readOnly}
				sx={{ mr: 0 }}
			/>
			{Boolean(checkbox?.label) && <Separator label="+" sx={{ ml: "5px" }} />}
			<InputFormExtension {...input} disabled={input?.disabled || disabled} readOnly={input?.readOnly || readOnly} />
		</Stack>
	);
}
CheckInput.propTypes = {
	checkbox: PropTypes.shape({
		label: PropTypes.string,
		checked: PropTypes.bool,
		handleChange: PropTypes.func,
	}),
	input: PropTypes.shape({
		data: PropTypes.array,
		value: PropTypes.number,
		defaultType: PropTypes.string,
		error: PropTypes.bool,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		sx: PropTypes.object,
		onActionUpdate: PropTypes.func,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		onClickText: PropTypes.func,
		onFocusOut: PropTypes.func,
	}),
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	componentProps: PropTypes.shape({
		sx: PropTypes.object,
	}),
};
